const isUndefined = (value) => {
  return typeof value === "undefined";
};

export default isUndefined;
